import { render, staticRenderFns } from "./SummaryOrderDetails.vue?vue&type=template&id=9fe7dc50&lang=pug&"
import script from "./SummaryOrderDetails.vue?vue&type=script&lang=js&"
export * from "./SummaryOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports